import { latestArticles } from "@/mocks/content";
import { Link } from "react-router-dom";

export default function ContentSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
              Latest Articles
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              Vigorbuy Spreadsheet Guides & Resources
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Stay informed with our latest guides, tutorials, and curated picks from the Vigorbuy Spreadsheet. Whether you are a beginner looking for your first find or an experienced user hunting for the best deals, our articles help you make smarter buying decisions.
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              The Vigorbuy Spreadsheet 2026 is the most comprehensive resource available — and our guides make it even easier to use. From step-by-step tutorials to top product picks across every category, our content is designed to save you time.
            </p>
            <Link
              to="/guide/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read All Guides
              <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {latestArticles.map((article, idx) => (
              <Link
                key={idx}
                to={article.url}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-200/50 transition-all cursor-pointer flex flex-col"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-accent-700 text-xs font-semibold whitespace-nowrap">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4 flex-1 flex flex-col">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug mb-2 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
                    {article.excerpt}
                  </p>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {article.readTime}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}